import { useQuery } from '@tanstack/react-query';
import { userService } from '../services/userService';
import type { UserQueryParams } from '../types';

interface UseUsersOptions {
  enabled?: boolean;
}

export function useUsers(params: UserQueryParams = {}, options: UseUsersOptions = {}) {
  return useQuery({
    queryKey: ['users', params],
    queryFn: () => userService.getUsers(params),
    enabled: options.enabled,
  });
}
